import { render, staticRenderFns } from "./LayListVideo.vue?vue&type=template&id=1c53e2c1&scoped=true&"
import script from "./LayListVideo.vue?vue&type=script&lang=js&"
export * from "./LayListVideo.vue?vue&type=script&lang=js&"
import style0 from "./LayListVideo.vue?vue&type=style&index=0&id=1c53e2c1&lang=less&scoped=true&"
import style1 from "./LayListVideo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53e2c1",
  null
  
)

export default component.exports